import type { HorizonAppLoaderContext } from '#/horizon/types/horizon-app-loader-context';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { authLoginRoute } from './auth.routes';

type Args = {
  request: Request;
  context: HorizonAppLoaderContext;
};

export function idealistRequireAuthentication({ request, context }: Args) {
  const url = new URL(request.url);

  return idealistRedirect({ request, context })(
    authLoginRoute.with({
      to: `${url.pathname}${url.search}`,
      // Use auth_required on hypernova
      auth_required: HORIZON_ENABLED ? undefined : 1,
    }),
    { flashMessage: { type: 'LOGIN_REQUIRED' }, status: 302 },
  );
}
